import { forAny, forBlock, setting, suggest, Suggestion, suggestMultiple } from "./PowerEditorSettingsSuggestions";

export const PowerEditorDefaultSuggestions: Suggestion[] = [
  suggest(forAny(),
    setting("_class")),
  suggest(forAny(),
    setting("_htmlid")),
  suggest(forAny(),
    setting("render_block_type")),
  
  ...suggestMultiple(forBlock("custom_fields_block"),
    setting("preconfigured_fields"),
    setting("edit_in_place", ["true", "false"]),
  ),

  ...suggestMultiple(forBlock("configurable_table_block"),
    setting("preconfigured_fields"),
    setting("list_fields"),
  ),

  ...suggestMultiple(forBlock("table"),
    setting("width"),
    setting("columns_width", ["50%; 25%; 25%"]),
    setting("no_border")
  ),
] 